<template>
  <el-row style="padding-bottom: 20px">
    <!-- 面包屑及搜索栏 -->
    <el-col class="breadcrumb-search">
      <!-- 面包屑 -->
      <div class="breadcrumb-block">
        <el-breadcrumb separator=">>">
          <el-breadcrumb-item :to="{ path: '/' }"
            ><span>当前位置：网站首页</span></el-breadcrumb-item
          >
          <el-breadcrumb-item
            ><span v-on:click="toSearchPage">搜索结果</span></el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
      <!-- 搜索栏 -->
      <div class="search-block">
        <div>
          <el-input
            v-model="searchValue"
            placeholder="快捷搜索"
            class="search-input"
            type="search"
            @keyup.enter.native="quickSearch"
          >
            <el-button
              @click="quickSearch"
              slot="append"
              class="serach-button"
              icon="el-icon-search"
            ></el-button>
          </el-input>
        </div>
      </div>
    </el-col>

    <el-col :span="24">
      <div class="search-result-block" v-if="!showNewsDetail">
        <div class="search-result-title">搜索结果</div>
        <div class="search-result-content">
          <div
            v-for="item in dataList"
            :key="item.id"
            class="search-result-item cur-pointer"
            @click="clickToNewsDetail(item)"
          >
            <div class="info-content-dot"></div>
            <div class="search-result-item-title ellipsis">
              <span v-if="item.typeTitle" style="margin-right: 10px">
                [{{ item.typeTitle }}]
              </span>
              <!-- <span>{{ item.title }}</span> -->
              {{ item.titleStart }}
              <span style="color: red">{{ item.searchValue }}</span>
              {{ item.titleEnd }}
            </div>
            <div class="search-result-item-opTime">
              {{ item.opTime }}
            </div>
          </div>
          <div class="pagination-block" v-if="!showNewsDetail && total !== 0">
            <el-pagination
              @current-change="handlePageChange"
              :current-page="currentPage"
              :page-size="currentSize"
              layout="total, pager, jumper"
              :total="total"
              :small="pageSmallBool"
              :pager-count="pagerCount"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div v-else-if="showNewsDetail" class="html-block">
        <div v-html="contents"></div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { searchAllDataListApi } from "@/api/searchDataApi";
import shareMethods from "@/common/shareMethods";
export default {
  name: "home",
  components: {},
  data() {
    return {
      funcId: "3",
      asidId: "",
      currentPage: 1,
      currentSize: 10,
      total: 0,
      searchValue: "",
      bannerList: [],
      dataList: [],
      functionList: [],
      dataIndex: 0,
      routerName: "",
      showNewsDetail: false,
      contents: "",
      openType: 0,
      mobiePhoneShow: true,
      pageSmallBool: false,
      pagerCount: 7,
    };
  },
  mixins: [shareMethods],
  created() {

    let imgUrl = "https://www.csysedu.com/favicon.png";
    let linkUrl = window.location.href ;
    let desc = "长沙市唯上商务科技学校";
    let title = "长沙市唯上商务科技学校";
    this.share(imgUrl, linkUrl,desc, title );

    this.searchValue = this.$route.query.searchValue;
    this.searchAllDataListFun();
    this.handleResize();
  },

  watch: {
    // 监听,当路由发生变化的时候执行
    $route: "handleToNewPage",
  },

  methods: {
    handleToNewPage() {
      this.searchValue = this.$route.query.searchValue;
      this.searchAllDataListFun();
    },
    searchAllDataListFun() {
      this.showNewsDetail = false;
      searchAllDataListApi(
        this.currentPage,
        this.currentSize,
        this.searchValue
      ).then((res) => {
        var tmpArr = [];
        var tmpObj = {};
        var resultMsg = res.rows.length == 0 ? "未查询到数据。" : "查询成功!";
        this.$message({
          type: "success",
          message: resultMsg,
        });
        res.rows.forEach((item, index) => {
          var tmpIndex = item.title.indexOf(this.searchValue);
          tmpObj.typeTitle = item.function ? item.function.name : "";
          tmpObj.titleStart = item.title.slice(0, tmpIndex);
          tmpObj.searchValue = this.searchValue;
          tmpObj.titleEnd = item.title.slice(
            tmpIndex + this.searchValue.length,
            item.title.length
          );
          tmpArr[index] = { ...item, ...tmpObj };
        });
        this.dataList = tmpArr;
        this.total = res.total;
      });
    },
    toSearchPage() {
      this.searchAllDataListFun();
    },

    handleResize() {
      var html = document.getElementsByTagName("html")[0];
      var oWidth =
        document.body.clientWidth || document.documentElement.clientWidth;
      // 这里的750是指设计图的大小,自己根据实际情况改变
      html.style.fontSize = (oWidth / 1440) * 10 + "px";
      this.mobiePhoneShow = oWidth < 768 ? true : false;
      var screenWidth = window.innerWidth;

      if (oWidth < 1439) {
        // 600到1439像素之间的样式处理
        this.pageSmallBool = true;
        this.pagerCount = 5;
      } else {
        this.pageSmallBool = false;
        this.pagerCount = 7;
      }
    },

    quickSearch() {
      this.$router.push({
        path: "/searchAllData",
        query: { searchValue: this.searchValue },
      });
      this.showNewsDetail = false;
      this.currentPage = 1;
      this.currentSize = 10;
      this.searchAllDataListFun();
    },

    handlePageChange(val) {
      this.currentPage = val;
      window.scrollTo(0, 0);
      this.searchAllDataListFun();
    },

    clickToNewsDetail(item) {
      this.$router.push({
        path: "/searchAllData",
        query: { searchValue: this.searchValue },
      });
      if (item && item.source) {
        window.open(item.source, "_blank");
      } else {
        this.showNewsDetail = true;
        var tmpcontents = item.detail;
        // let r = RegExp(/<[(img|iframe)]+\s+(.*?)(?<id>\w*?)[\s'"](.*?)>/g);
        // 获取文本中style部分
        var reg = RegExp(/<iframe\s+(.*?)(?<id>\w*?)[\s'"](.*?)>/g);
        var matchres = tmpcontents.match(reg);
        // 获取style部分中width部分
        var widthReg = RegExp(/\bwidth\b\:\s+(.*?)\;/g);
        // 获取style部分中height部分
        var heightReg = RegExp(/\bheight\b\:+\s+(.*?)\;/g);
        // let matchres = tmpcontents.match(r); //返回数组['<img ... />','<img ... />']
        var imglength = this.mobiePhoneShow ? "120rem" : "100%";
        if (matchres) {
          matchres.forEach((item, index) => {
            var innnermatchres = item.match(/(style=\")+\s*(.*?)\"/g);
            innnermatchres.forEach((inneritem, index) => {
              var widthMatch = inneritem.match(widthReg);
              var heightMatch = inneritem.match(heightReg);
              if (widthMatch && heightMatch) {
                var realwidth = widthMatch[0].match(/\d+/g);
                var realheight = heightMatch[0].match(/\d+/g);
                var finalheight;
                if (realwidth && realheight) {
                  finalheight =
                      (realheight[0] / realwidth[0]) * (this.mobiePhoneShow ? "144" : "105.6") + "rem";
                }
                let _str =
                  'style="width:' +
                  imglength +
                  " !important;height:" +
                  finalheight +
                  ';text-align:center;"'; //追加之后的img
                tmpcontents = tmpcontents.replace(inneritem, _str);
              }
            });
          });
          // 获取style部分中width部分
        }
        let r = RegExp(/<img\s+(.*?)(?<id>\w*?)[\s'"](.*?)>/g);
        let matchresArray = tmpcontents.match(r); //返回数组['<img ... />','<img ... />']
        // 判断标签是否含有style，含有替换
        // (?<=<p\s+style=").*(?=">)
        if (matchresArray && matchresArray.length > 0) {
          matchresArray.forEach((item, index) => {
            let len = item.length;
            if (item.indexOf("style") < 0) {
              // 不含style 新增
              let _newStyleStr =
                item.slice(0, len - 2) +
                '" style="max-width: 100%  !important; width: 100%;height:auto !important;text-align:center;"/>'; //追加之后的img
              tmpcontents = tmpcontents.replace(item, _newStyleStr);
            } else {
              var startStyleIndex = item.indexOf("style") + 7;
              var endStyleIndex = item.indexOf('"', startStyleIndex);
              let _styleStr =
                "width:" +
                imglength +
                ";max-width: 100%; height:auto !important;text-align:center;";
              // 判断标签是否含有style，含有替换
              tmpcontents = tmpcontents.replace(
                item.slice(startStyleIndex, endStyleIndex),
                _styleStr
              );
            }
          });
        }

        let tableReg = RegExp(/<table\s+(.*?)(?<id>\w*?)[\s'"](.*?)>/g);
        let tableMatchresArray = tmpcontents.match(tableReg); //返回数组['<img ... />','<img ... />']
        if (tableMatchresArray && tableMatchresArray.length > 0) {
          tableMatchresArray.forEach((item, index) => {
            let len = item.length;
            if (item.indexOf("style") < 0) {
              // 不含style 新增
              let _newStyleStr =
                item.slice(0, len - 2) +
                '" style="max-width: 100%  !important; width: 120rem !important;height:auto !important;text-align:center;"/>'; //追加之后的img
              tmpcontents = tmpcontents.replace(item, _newStyleStr);
            } else {
              var startStyleIndex = item.indexOf("style") + 7;
              var endStyleIndex = item.indexOf('"', startStyleIndex);
              let _styleStr =
                "width:" +
                imglength +
                ";max-width: 100%; height:auto !important;text-align:center;";
              // 判断标签是否含有style，含有替换
              tmpcontents = tmpcontents.replace(
                item.slice(startStyleIndex, endStyleIndex),
                _styleStr
              );
            }
          });
        }
        this.contents = tmpcontents;
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.showNewsDetail = false;
    next((vm) => {});
  },
  computed: {},
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
.banner-block {
  display: flex;
  flex-direction: column;
  .carousel_title {
    margin: 85px 0 0 38px;
    font-size: 40px;
    min-height: 52px;
    width: 90vw;
    line-height: normal;
    font-weight: 700;
  }

  .carousel_description {
    margin: 6px 0 0 38px;
    font-size: 18px;
    width: 90vw;
    line-height: normal;
    min-height: 52px;
    font-weight: 400;
  }

  .carousel_button {
    margin: 22px 0 0 38px;
    font-size: 14px;
    width: 90vw;
    min-height: 52px;
    font-weight: 400;
  }
}

.breadcrumb-search {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 120rem;
  margin: 20px 12rem 20px 12rem;
  .breadcrumb-block {
    width: 700px;
    margin-left: 22rem;
    font-weight: 400;
    display: flex;
    flex-direction: row;
    .el-breadcrumb {
      height: 20px;
      span {
        font-size: 14px;
        height: 20px;
        color: #0e517a;
        line-height: 20px;
      }
    }
  }
}

.search-block {
  margin-right: 16rem;
  width: 290px;
  height: 32px;
  div {
    width: 290px;
    height: 32px;
    .search-input {
      .serach-button {
        background-color: #255077;
        height: 100%;
      }
    }
  }
}

.search-result-block {
  width: 90rem;
  margin: 0 27rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  .search-result-title {
    font-size: 20px;
    font-weight: 500;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #00537c;
    width: 90rem;
    background: #c7dde8;
  }
  .search-result-content {
    width: 90rem;
    margin: 0 27rem;
    font-size: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .search-result-item {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      height: 60px;
      width: 90rem;
      border: 1px solid #e8e8ea;
      .info-content-dot {
        width: 8px;
        height: 8px;
        background-color: #255077;
        border-radius: 50%;
        margin-right: 12px;
      }
      .search-result-item-title {
        width: 75rem;
        font-size: 16px;
        font-weight: bold;
        color: #6e728a;
      }
      .search-result-item-opTime {
        text-align: end;
        margin-right: 24px;
        white-space: nowrap;
        font-size: 16px;
        font-weight: bold;
        color: #6e728a;
        flex-grow: 1;
      }
      &:hover {
        .search-result-item-opTime,
        .search-result-item-title {
          color: #0e517a !important;
        }
      }
    }
  }
}

.html-block {
  width: 120rem;
  margin: 0 12rem;
  margin-top: 20px;
  border: 1px solid #f1f1f1;
}

@media only screen and (max-width: 1920px) {
}

@media only screen and (max-width: 1439px) {
}

@media only screen and (max-width: 1330px) {
}

@media only screen and (max-width: 1200px) {
}

@media only screen and (max-width: 992px) {
  .breadcrumb-search {
    flex-direction: column;
    justify-content: start;
    align-items: start;

    .breadcrumb-block {
      width: 280px;
      font-weight: 400;
      display: flex;
      margin-left: 0;
      flex-direction: row;
      .el-breadcrumb {
        span {
          font-size: 14px;
          height: 20px;
          color: #0e517a;
          line-height: 20px;
        }
      }
    }
    .search-block {
      width: 120rem;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
      div {
        width: 290px;
        height: 32px;
        .search-input {
          .serach-button {
            background-color: #255077;
            height: 100%;
          }
        }
      }
    }
  }

  .search-result-block {
    width: 120rem;
    margin: 0 12rem;
    .search-result-title {
      font-size: 16px;
      width: 120rem;
    }
    .search-result-content {
      width: 120rem;
      margin: 0 12rem;
      font-size: 24px;
      .search-result-item {
        width: 120rem;
        .search-result-item-title {
          width: 80rem;
          font-size: 12px;
        }
        .search-result-item-opTime {
          margin: 0 10px 0 20px;
          font-size: 12px;
        }
      }
    }
  }

  .pagination-block {
    margin-top: 10px;
  }

  .common-block {
    margin: 0 12rem;
    width: 120rem;
  }
}

@media only screen and (max-width: 768px) {
  .breadcrumb-search {
    width: 128rem;
    margin: 20px 8rem 20px 8rem;
    .search-block {
      width: 128rem;
    }
  }
}

@media only screen and (max-width: 520px) {
  .search-block {
    width: 120rem;
    div {
      width: 120rem;
    }
  }
  .search-result-block {
    width: 140rem;
    margin: 0 2rem;
    .search-result-title {
      font-size: 16px;
      width: 140rem;
      margin: 0 2rem;
    }
    .search-result-content {
      width: 140rem;
      margin: 0 2rem;
      font-size: 24px;
      .search-result-item {
        width: 140rem;
        margin: 0 2rem;
        .search-result-item-title {
          width: 90rem;
          font-size: 12px;
        }
        .search-result-item-opTime {
          margin: 0 10px 0 20px;
          font-size: 12px;
        }
      }
    }
  }
  .pagination-block {
    .el-pagination {
      ::v-deep .el-pagination__jump {
        margin-left: 0 !important;
      }
    }
  }
}
</style>
